import '../../Pages/Client/AO/AODetails.scss';
import '../../Pages/Client/AO/Alertes.scss';

import { Star } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
//import StarIcon from '@mui/icons-material/Star';
//import StarHalfIcon from '@mui/icons-material/StarHalf';
import { AppBar, Avatar, Dialog, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Toolbar, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useAuth from '../../hooks/useAuth';
import { getNomPrenomClearFromPersoData } from '../../Utils/utils';
import { Transition } from '../shared/ReusableSmallComponents';

function DialogCommentPriveCv({ commentaires, openDialogCommentPriveCv, setOpenDialogCommentPriveCv }) {
    DialogCommentPriveCv.propTypes = {
        commentaires: PropTypes.array,
        openDialogCommentPriveCv: PropTypes.any,
        setOpenDialogCommentPriveCv: PropTypes.func,
    };
    const { i18n } = useTranslation();
    console.log({ comment: commentaires });
    const handleCloseDialogCommentPriveCv = () => {
        setOpenDialogCommentPriveCv(false);
    };

    const { auth } = useAuth();

    return (
        <Dialog
            open={openDialogCommentPriveCv}
            onClose={handleCloseDialogCommentPriveCv}
            TransitionComponent={Transition}
            fullScreen
            scroll={'paper'}
            PaperProps={{
                style: {
                    background: 'white',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseDialogCommentPriveCv}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            {/*  <List
                                sx={{ width: '100%', bgcolor: 'background.paper' }} //maxWidth: 360,
                                key={i}
                            > */}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '170px', minHeight: '900px' }}>
                <div
                    className='createalertediv'
                    style={{width:'max-content'}}
                >
                    <h4 className='titlesociete'>{i18n.t('Vos commentaires privés sur ce CV')}</h4>
                    { Array.isArray(commentaires) && commentaires.length > 0 ?
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignSelf: 'stretch' }}>
                            <List sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}>
                                {Array.isArray(commentaires) && commentaires.map((comment, i) => (

                                    <div key={i}>
                                        <ListItem
                                            alignItems="flex-start"
                                            sx={((comment?.collaboratorId?._id == auth?.collaboratorId) || (comment?.collaboratorEsnId?._id == auth?.collaboratorEsnId)) ? { bgcolor: ' #E7EAF9' } : {bgcolor: '#F8F9FA'}}
                                        >
                                            {/* {JSON.stringify(comment)} */}
                                            <ListItemAvatar>
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={comment?.collaboratorId?.persoData?.photo ?? comment?.collaboratorEsnId?.persoData?.photo}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body2"
                                                            color="text.primary"
                                                        >
                                                            <span
                                                                style={{
                                                                    fontFamily: 'Lato',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: '800',
                                                                    fontSize: '20px',
                                                                    lineHeight: '28px'}}
                                                            >{getNomPrenomClearFromPersoData(comment?.collaboratorId?.persoData ?? comment?.collaboratorEsnId?.persoData)}</span>
                                                            &nbsp;  &nbsp; &nbsp;
                                                            {comment?.evaluation && (
                                                                <>
                                                                    {Array(parseInt(comment?.evaluation)).fill().map((_, i) => (
                                                                        <Star
                                                                            style={{ color: '#faaf00',width:'20px' }}
                                                                            key={i}
                                                                        />
                                                                    ))}
                                                                </>
                                                            )}
                                                        </Typography>
                                                    </React.Fragment>
                                                }
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body2"
                                                            color="text.primary"
                                                        >
                                                            <span
                                                                style={{
                                                                    fontFamily: 'Lato',
                                                                    fontStyle: 'normal',
                                                                    fontWeight: '500',
                                                                    fontSize: '15px',
                                                                    letterSpacing: '-0.0044em',
                                                                    color:'#272D3C',
                                                                    lineHeight: '20px'}}
                                                            >{comment?.commentaire}</span>
                                                        </Typography>
                                                        {/* {' — I\'ll be in your neighborhood doing errands this…'} */}
                                                    </React.Fragment>
                                                }
                                            />
                                            {/*<ListItemAvatar>

                                            </ListItemAvatar>*/}
                                        </ListItem>
                                        <Divider
                                            variant="inset"
                                            component="li"
                                            sx={{width:'100%',marginLeft:'0px'}}
                                        />
                                    </div>
                                ))}
                            </List>
                        </div>
                        :
                        <div  style={{display:'flex',flexDirection:'column',gap:'8px',alignSelf:'stretch'}}>
                            <p style={{fontFamily:'Lato',fontWeight:'400px',fontSize:'16px',lineHeight: '24px',color:'black',marginLeft:'10px'}}>{i18n.t('Aucun commentaire sur ce CV')}</p>
                        </div>
                    }
                </div>
            </div>
        </Dialog>
    );
}

export default DialogCommentPriveCv;
